import { render, staticRenderFns } from "./prospect-usdots.vue?vue&type=template&id=4f320a53"
import script from "./prospect-usdots.vue?vue&type=script&lang=js"
export * from "./prospect-usdots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports